import React, {createContext} from "react"
import {graphql, Link} from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Hero from "../components/hero"
import Pagination from "../components/pagination"

import {Container, Post} from "../components/blog"

const BlogPage = ({location, pageContext, data}) => {
  const {
    allMdx: {edges},
    sticky: {edges: stickyEdges},
    image
  } = data

  const config = {
    heroBackgroundImage: image,
    heroH1: "Blog",
    heroCaption: "Telephone Cable Stranding Machine | 1922"
  }

  return (
    <Layout location={location}>
      <SEO title="Blog" />
      <Hero {...config} />
      <Container theme="">
        {stickyEdges.map((edge, idx) => (
          <Post key={idx} post={edge.node} sticky={true} />
        ))}
        {edges.map((edge, idx) => (
          <Post key={idx} post={edge.node} />
        ))}
      </Container>
      <Pagination {...pageContext} basePath="/blog" />
    </Layout>
  )
}

export default BlogPage

export const pageQuery = graphql`
  query($skip: Int!, $limit: Int!) {
    allMdx(
      filter: {collection: {eq: "blog"}, fields: {order: {lte: 0}}}
      sort: {fields: [frontmatter___date], order: DESC}
      skip: $skip
      limit: $limit
    ) {
      edges {
        node {
          slug
          frontmatter {
            title
            date(formatString: "MMMM D, YYYY")
            categories
          }
          excerpt(pruneLength: 100)
        }
      }
    }
    sticky: allMdx(
      filter: {collection: {eq: "blog"}, fields: {order: {gt: 0}}}
      sort: {fields: [frontmatter___order], order: ASC}
    ) {
      edges {
        node {
          slug
          frontmatter {
            title
            date(formatString: "MMMM D, YYYY")
            categories
          }
          excerpt(pruneLength: 100)
        }
      }
    }
    image: file(relativePath: {eq: "photos/support-header.png"}) {
      publicURL
      relativePath
      dev
      base
      data: childImageSharp {
        resolutions(width: 1200) {
          width
          height
          src
          srcSet
        }
      }
    }
  }
`
